import React from 'react';
import { DropdownItem, DropdownList, Input } from '@cokitchen/cokitchen-components';
import PlacesAutocomplete from 'react-places-autocomplete';

const searchOptions = {
  componentRestrictions: { country: ['ng'] }
};

type Props = {
  value: string;
  label?: string;
  placeholder?: string;
  onChange: (address: string) => void;
};

const AddressInput = (props: Props) => {
  const { value, label, placeholder, onChange } = props;

  return (
    <PlacesAutocomplete
      value={value}
      onChange={onChange}
      onSelect={onChange}
      searchOptions={searchOptions}>
      {({ loading, suggestions, getInputProps, getSuggestionItemProps }) => (
        <div>
          <Input design='bordered' {...getInputProps({ label, placeholder })} />
          {suggestions?.length ? (
            <DropdownList className='max-h-[200px]'>
              {loading ? <DropdownItem>Loading...</DropdownItem> : null}
              {suggestions.map((suggestion) => (
                <div {...getSuggestionItemProps(suggestion)} key={suggestion.index}>
                  <DropdownItem>{suggestion.description}</DropdownItem>
                </div>
              ))}
            </DropdownList>
          ) : null}
        </div>
      )}
    </PlacesAutocomplete>
  );
};

export default AddressInput;
